import { useEffect, useState } from "react";
import Loader from "src/control-components/custom-drawer/custom-drawer"
import MyComponent from "../client/client-profile/questionnaire/questionnaire-module/patient-health-questionnaire";
import { useLocation } from "react-router";
import { useNavigate } from "react-router";
import { API_ENDPOINTS } from "src/services/api-endpoints";
import { customAxios } from "src/services/useExPressApi";
import { SELECTED_CLIENT_ID } from "src/redux/actions/types";
import { useDispatch, useSelector } from "react-redux";
import DEVELOPMENT_CONFIG from "../../helper/config"
import DropDownListComponent from "src/control-components/drop-down-component/drop-down";


function UpdateClientQuestionnaire() {
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const selectedClientId = useSelector((state) => state.selectedClientId);
  const [loading, setLoading] = useState(false);
  const [questionsDetails, setQuestionDetails] = useState();
  const [questionList, setQuestionList] = useState([]);
  const [questionListById, setQuestionListById] = useState([]);
  const [isQueInfoFetched, setIsQueInfoFetched] = useState(false);
  let token = localStorage.getItem(DEVELOPMENT_CONFIG.TOKEN);
      
  useEffect(() => {
      dispatch({
        type: SELECTED_CLIENT_ID,
        payload: location?.state?.field?.clientId,
      });
  }, [])

  useEffect(() => {
    getQuestions();
    getQuestionsById();
  }, [])

  const handleChange = (e) => {
    const value = e.target.value;
    setQuestionDetails(value);
  };

  const getQuestionsById = async () => {
    const data = {
      id: location?.state?.field?.id
    }
    const metaResponse = await customAxios.post(`${API_ENDPOINTS.GET_QUESTIONS_BY_Id}${data?.id}`, {} , {
      headers: {
        'Authorization': 'Bearer ' + location?.state?.field?.token, 
        'Content-Type': 'application/json',
      },
    });    
    if(metaResponse && metaResponse?.resultData) {
      let questionListById = metaResponse?.resultData?.data;
      setQuestionListById(JSON.parse(questionListById));
      setIsQueInfoFetched(true)
    }
  };

  const getQuestions = async () => {
          const metaResposne = await customAxios.get(`${API_ENDPOINTS.GET_QUESTIONS}`, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + location?.state?.field?.token
            },
          })
          if(metaResposne && metaResposne?.resultData) {
            let questionList = metaResposne?.resultData;
            setQuestionList(questionList);
          }
  };

  return <>
     <div className="d-flex flex-wrap">
       {loading === true && <Loader />}
       <div className="col-md-12 col-lg-12">
         <div className=" mt-5">
          {location == null ? (
            <div className=" col-lg-4 col-md-6 col-12 template">
              <DropDownListComponent
                label="Questions"
                onChange={handleChange}
                data={questionList}
                value={questionsDetails}
                textField="fullName"
                dataItemKey="id"
                placeholder="Questions"
              />
            </div>
          ) : (
            ""
          )}

         {isQueInfoFetched && <MyComponent
            key={location?.state?.field?.id}
            queId={location?.state?.field?.id}
            isFromCP={location.state.field.isFromCP}
            componentType={
              questionsDetails?.enumId || location?.state?.field?.enumId
            }
             questionId={questionsDetails?.id}
             questionListById={questionListById}
             token = {location?.state?.field?.token}
          />}
        </div>
      </div>
    </div>
  </>
}
export default UpdateClientQuestionnaire